import { useCDNLoader } from '@domgen/base-design-system-2.0/hooks/useCDNLoader';
import { cookieProInitialiser } from './cookiePro';
import { log } from '@domgen/shared/utils/log';

/**
 * It loads necessary third-party scripts (like cookie pro) after rendering the app.
 * If any critical script fails to load, it logs the error and prevents the app from rendering to avoid a broken user experience.
 * After the app is rendered, it starts loading deferred services like CookiePro based on the provided configuration.
 *
 * @param {Partial<CreateAppConfiguration>} deferredConfig - The configuration object for creating the app, including client logo, environment, brand code, version, reCAPTCHA site key, routes, and other service configurations.
 */
export const startDeferredServices = (deferredConfig: {
  environment?: 'sandbox' | 'development' | 'qa' | 'production';
  cookiePro?: {
    brandScriptId?: string;
    src?: string;
  };
  checkoutCDN?: string;
}) => {
  const { environment, cookiePro, checkoutCDN } = deferredConfig;
  if (cookiePro && cookiePro?.brandScriptId && cookiePro?.src && environment) {
    log.info({ message: 'Initializing CookiePro' });
    const { initialise } = cookieProInitialiser(environment);
    initialise(
      cookiePro?.brandScriptId,
      cookiePro?.src,
      ['sandbox', 'development', 'qa', 'production'],
      'cookiePro',
    );
  }
  if (checkoutCDN && environment) {
    log.info({ message: 'Loading Checkout SDK script' });
    const { loadScript } = useCDNLoader(environment);
    loadScript(checkoutCDN, 'checkoutSDK', ['sandbox', 'development', 'qa', 'production']);
  }
};
